import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './resetPassword.module.scss';
import DoctorAvatar from '../../static/images/doctor_avatar.png';
import utils from '../../utils/utils';
import { InputItem, Button, Toast } from 'antd-mobile';
import { Checkbox } from 'antd-mobile-v5';
import  { ApiCore } from '../../api/index';
import TitleComponent from './title/title';
import methods from '../../utils/methods';
import Utils from '../../utils/utils'
import { BASE_URL } from '../../config/config';
const api = new ApiCore();

const colorRed = { color: 'red' }
const colorBlack = { color: '#000' }
const colorGreen = { color: 'green' }

let clears: any = null;

function ResetPassword(props: any) {

    //手机号
    const [phone, setPhone] = useState<any>(null);
    //验证码
    const [codes, setCodes] = useState<any>('');
    //设置验证码颜色
    const [isRed, setColor] = useState<any>(colorBlack);
    //设置验证码文本
    const [showCode, setShowCode] = useState<boolean>(true);
    const [codeTxt, setcodeTxt] = useState<any>('获取验证码');
    //验证码倒计时
    const [countDownSecond, setCountDownSecond] = useState<any>(60);

    // 输入图形验证码
    const [graphCodes, setGraphCodes] = useState<any>(null);
    // 图形验证码url
    const [graphUrl, setGraphUrl] = useState<any>('');
    // 图形验证码是否验证通过
    const [isVerify, setVerify] = useState<any>(null);
    // uuid
    const [uuid, setUuid] = useState<any>('');
    // 是否发送验证码
    const [isSendCode, setIsSendCode] = useState<any>(false);
    const [checkedState, setCheckedState] = useState<any>(false);
    // 是否可以进行下一步
    const [isValid, setIsValid] = useState(false);
    useEffect(() => {
        //设置网页title
        document.title = '重置密码';
        // // 活动activityCode
        // let activityCode = Utils.getUrlParams().activityCode
        // // 获取项目projectCodes
        // let projectCodes = Utils.getUrlParams().projectCodes
        // // 获取租户tenantCode
        // let tenantCode = Utils.getUrlParams().tenantCode
        // if (activityCode || projectCodes || tenantCode) {
        //     let applyCodes = {
        //         tenantCode,
        //         projectCodes
        //     }
        //     sessionStorage.setItem('applyCodes', JSON.stringify(applyCodes))
        //     sessionStorage.setItem('activityCode', activityCode)

        //     // 报名流程可配置化
        //     getActivityCode(activityCode)

        //     // 肿瘤医学院项目
        //     sessionStorage.setItem('medicalLiveProject', 'true')
        // }

        // 获取图形验证码
        let code = methods.RndNum(9)
        setGraphUrl(`${BASE_URL}/plat/user/captcha.jpg?uuid=${code}`)
        setUuid(code)

    }, [])
    
    // // 获取报名活动
    // const getActivityCode = (activityCode: any) => {
    //     let params = {
    //         activityCode: activityCode ?? 'YMTSPZJ'
    //     }
    //     api.getProjectActivity(params).then(res => {
    //         if (res.code == '0') {
    //             if (!res.data || Object.keys(res.data).length == 0) {
    //                 return
    //             }
    //             let configData = {
    //                 syncArea: res.data.syncArea,
    //                 syncSite: res.data.syncSite,
    //                 syncSource: res.data.syncSource,
    //                 provinceLevel: res.data.provinceLevel,
    //                 cityLevel: res.data.cityLevel,
    //                 titleList: res.data.titleList,
    //                 departmentList: res.data.departmentList,
    //                 uploadIdPhotoNote: res.data.uploadIdPhotoNote,
    //                 uploadIdPhotoExample: res.data.uploadIdPhotoExample,
    //                 accountNameSyncType: res.data.accountNameSyncType,
    //             }
    //             sessionStorage.setItem('configData', JSON.stringify(configData))
    //             sessionStorage.setItem('IsPreSign', res.data.isPreSign);
    //         }
    //         else {
    //             Toast.fail(res.message)
    //         }
    //     })
    // }

    //输入图形验证码
    const onGraphCode = (value: any) => {
        setGraphCodes(value)
    }
    // 重新获取图形验证码
    const sendGraphCode = (value: any) => {
        let code = methods.RndNum(9)
        // setGraphUrl(`${BASE_URL}/plat/apply/captcha.jpg?uuid=${code}`)
        setGraphUrl(`${BASE_URL}/plat/user/captcha.jpg?uuid=${code}`)
        setUuid(code)
    }

    //60s验证码倒计时
    const handleCountDown = (seconds = 60) => {
        let second = seconds;
        const countDown = () => {
            if (second > 0) {
                second--;
                setCountDownSecond(second);
            }
            if (second === 0) {
                second = 60;
                setCountDownSecond(second);
                setShowCode(true);
                setIsSendCode(false);
                setcodeTxt('重新获取验证码');
                return;
            }
            clears = setTimeout(countDown, 1000);
        };
        clears = setTimeout(countDown, 1000);
    };

    // 手机号
    const onPhoneNumber = (value: any) => {
        setPhone(value)

        setGraphCodes('')
        setCodes('')

        setShowCode(true);
        setcodeTxt('获取验证码');
        setVerify(null)
        setIsSendCode(false);

        clearTimeout(clears)
    }
    // 发送验证码
    const sendCode = (value: any) => {
        if (!phone || phone === '') {
            Toast.fail('请输入手机号', 0.8)
        }
        else if (phone.length < 13) {
            Toast.fail('请正确输入手机号！', 0.8)
        }
        else if (graphCodes === '') {
            Toast.fail('请输入图形验证码', 0.8)
        }
        else {
            let params = {
                phone: methods.trim(phone, 'g'),
                imgUUId: uuid,
                imgCode: graphCodes
            }

            api.GetSmsCode(params).then(res => {
                if (res.code == '0') {
                    setIsSendCode(true);
                    setShowCode(false);
                    handleCountDown(60);
                    setVerify(true)
                    setIsValid(true)
                }
                else {
                    Toast.fail(res.message, 0.8)

                    let code = methods.RndNum(9)
                    setGraphUrl(`${BASE_URL}/plat/user/captcha.jpg?uuid=${code}`)
                    setUuid(code)
                    setGraphCodes(null)

                }
            })
        }

    }
    //获取验证码
    const onCode = (value: any) => {
        setCodes(value);
        setColor(colorBlack);
    }

    const onChange = (e: any, type: any) => {
        setCheckedState(!checkedState)
    }

    const toNext = () => {
        if (!phone) {
            Toast.fail('请输入手机号！', 0.8)
            return
        }
        if (phone.length < 13) {
            Toast.fail('请正确输入手机号！', 0.8)
            return
        }
        if (!graphCodes) {
            Toast.fail('请输入图形验证码！', 0.8)
            return
        }
        if (!codes) {
            Toast.fail('请输入短信验证码！', 0.8)
            return
        }
        let params = {
            phone: phone ? methods.trim(phone, 'g') : '',
            phoneCode: codes
        }
        api.ToResetPhoneValidate(params).then(res => {
            if (res.code == '0') {
                if (res.data) {
                    sessionStorage.setItem('ResetNewPdwCode', res.data);
                    props.history.push('/doctor/resetNewPwd');
                }
            } else {
                Toast.fail(res.message || '验证失败', 0.8)
            }
        });
    }

    return (
        <div className={`${styles.resetPassword_content}`}>
            <div className={styles.setPhone_content}>

            <TitleComponent title={'请输入您要重置密码的手机号'} subTitle={'将会为该手机号设置新的登录密码'} />

            <div className={styles.form_content}>
                <div className={styles.phonoNumber_login}>
                    <div className={`${styles.InputItemContent} ${styles.phoneWrap}`}>
                        <label className={styles.label}>手机号</label>
                        <InputItem
                            value={phone}
                            type="phone"
                            placeholder="请输入手机号"
                            onChange={onPhoneNumber}
                            clear
                        >+86</InputItem>
                    </div>

                    <div className={`${styles.InputItemContent}`}>
                        <label className={styles.label}>图形验证码</label>
                        <span className={`${styles.graphWrap}`}>
                            <InputItem
                                disabled={!phone}
                                value={!phone ? '' : graphCodes}
                                placeholder="请输入图形验证码"
                                type='text'
                                maxLength={5}
                                onChange={onGraphCode}
                                extra={
                                    <span
                                        hidden={!isVerify}
                                        className={isVerify ? `${colorGreen}` : `${colorRed}`}
                                    >
                                        {isVerify ? `验证通过 ` : `验证失败 `}
                                    </span>
                                }
                            ></InputItem>
                            <div className={`${styles.graph}`}>
                                <img
                                    src={graphUrl}
                                    alt=''
                                    onClick={sendGraphCode}
                                />
                            </div>

                        </span>
                    </div>

                    <div className={`${styles.InputItemContent} ${styles.smsWrap}`}>
                        <label className={styles.label}>验证码</label>
                        <InputItem
                            disabled={!graphCodes}
                            value={codes}
                            placeholder="请输入短信验证码"
                            type='number'
                            maxLength={6}
                            extra={
                                showCode ?
                                    <Button disabled={!graphCodes} onClick={sendCode} type="primary">{codeTxt}</Button> :
                                    <Button disabled={!graphCodes}>{`${countDownSecond}s`}</Button>
                            }
                            onChange={onCode}
                            style={isRed}
                        ></InputItem>
                    </div>
                </div>
            </div>
            <Button className={`${styles.complete_btn}`} disabled={!isValid} type='primary' onClick={() => { toNext() }}>下一步</Button>
            <div className={`${styles.warn_text}`} >
                若您的登录账号为自定义账号而非手机号，请联系管理员为您重置密码
            </div>
            </div>
        </div>
    )

}

export default ResetPassword;